import type { AstroLocale } from '@/schemas/components/shared/i18n';
import type { LocationDropdownItem } from '@/components/react/form/select-values/updateOrder';

export function autoPrependDialCode({
  phone,
  country,
  prevCountry,
  sortedCountries,
  language,
}: {
  phone: string;
  country: string;
  prevCountry: string | null;
  sortedCountries: LocationDropdownItem[];
  language: AstroLocale;
}): string {
  // Find the selected country object
  const selected = sortedCountries.find((c) => {
    const name = c[language] || c.valueOverride;
    return name === country || c.valueOverride === country;
  });

  // Find the previous country object
  const prevSelected =
    prevCountry ?
      sortedCountries.find((c) => {
        const name = c[language] || c.valueOverride;
        return name === prevCountry || c.valueOverride === prevCountry;
      })
    : null;

  if (!selected || !selected.dial_code) return phone;

  // If the phone field is empty, just use the dial code
  if (!phone) return selected.dial_code;

  // If the phone starts with the previous dial code, remove it
  if (
    prevSelected
    && prevSelected.dial_code
    && phone.startsWith(prevSelected.dial_code)
  ) {
    phone = phone.slice(prevSelected.dial_code.length);
  }

  // If the phone already starts with the correct dial code, do nothing
  if (phone.startsWith(selected.dial_code)) return phone;

  // Remove a leading + if present (and not part of a dial code)
  if (phone.startsWith('+')) phone = phone.slice(1);

  // Prepend the new dial code
  return selected.dial_code + phone;
}
